import { ListItemAvatar, useMediaQuery } from '@mui/material';
import React from 'react';
import { useSelector } from 'store';
import { ChatUserModel } from 'types/chat-users/chat-user';
import UserAvatarComponent from 'ui-component/display/UserAvatar';

/* === Chat User Avatar === */
interface UserAvatarProps {
  user: ChatUserModel;
}
const UserAvatar: React.FC<UserAvatarProps> = ({ user }) => {
  const matchesBigMobile = useMediaQuery((theme) => theme.breakpoints.down(768));
  const showAvatar = useSelector((state) => state.userConfig.isAvatarActive);

  if (!showAvatar) return null;
  return (
    <ListItemAvatar>
      {/* <Avatar
        src={user.UserPic || undefined}
        sx={{
          //? width: applicationType === 'extension' || matchesBigMobile ? 40 : 55,
          // height: applicationType === 'extension' || matchesBigMobile ? 40 : 55,
          // mr: applicationType === 'extension' || matchesBigMobile ? 1 : 1.5,
          width: matchesBigMobile ? 40 : 50,
          height: matchesBigMobile ? 40 : 50,
          mr: matchesBigMobile ? 1 : 1.5,
        }}
      /> */}
      <UserAvatarComponent
        src={user.UserPic || undefined}
        userName={user.FullName}
        status={user.isRestricted24 ? 'available' : 'offline'}
        sx={{
          width: matchesBigMobile ? 40 : 50,
          height: matchesBigMobile ? 40 : 50,
        }}
      />
    </ListItemAvatar>
  );
};

export default UserAvatar;
